import PageComponents from './views/PageComponents.vue';
import Menu from './components/Menu.vue';
import Messages from './components/Messages.vue';
import InputSend from './components/InputSend.vue';

export default [
  {
    path: '/components',
    component: PageComponents,
    children: [{
      path: 'menu',
      name: 'Menu',
      component: Menu,
      props: {
        isMobile: false,
        currentChat: {},
        route: {
          name: 'teste',
          path: '/teste',
        }, currentUser: {
        },
      },
    }, {
      path: 'messages',
      name: 'Messages',
      component: Messages,
      props: { messages: [
        { objectId: '1', text: 'testee' },
        { objectId: '2', text: `testee2a aksdjkajs dkajsk djaksd
          jaksjd kaj skdj aksdj kajs dka j', status: 'OUTGOING_SENT`,
        },
        { objectId: '3', text: 'testee3', status: 'OUTGOING_SENT' },
        { objectId: '4', text: 'testee4'},
        { objectId: '5', text: 'testee5', status: 'OUTGOING_SENT' },

      ] },
    }, {
      path: 'inputSend',
      name: 'InputSend',
      component: InputSend,
      props: { isMobile: false },
    }],
  },
];

